import {useEffect, useState} from 'react'
import {useContentfulClient} from './use-contentful-client.hook'
import {useIntl} from 'react-intl'

export const useFilters = (slug) => {
    const {locale} = useIntl()
    const contentfulClient = useContentfulClient()

    const [data, setData] = useState(null)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        contentfulClient
            .getEntries({
                'fields.slug': slug,
                locale,
                content_type: 'filter',
                include: 10
            })
            .then((response) => {
                const item = (response?.items ?? [])?.at(-1)?.fields ?? null
                if (item)
                    setData({
                        ...item,
                        sections: item?.sections ?? []
                    })
            })
            .catch((error) => {
                setError(error)
                console.error('>>>> error', error)
            })
            .finally(() => setIsLoading(false))
    }, [])

    return {data, isLoading, error}
}
